<template>
  <div class="P_left"  @mouseleave="handleMouseLeave">
    <!-- <div class="content_box"> -->
     
       
        
         <div class="list_box w-100">
          <div class="container-fluid">
            <div class="row gutter-0 wap-gutter-10">
            <productTypeLeft  @selectType="selectType" @changeValue="changeValue"></productTypeLeft>
          <!-- <div class="col-3 col-xs-6"> -->
          <!-- <div>-->
            <div class="col-md-9 col-xs-12 wow bounceInRight"> 
              <div class="row">
                <div class="col-md-3 col-xs-6 wow fadeInUp " v-for="(item,index) in list" :key="index" data-wow-delay="0.1s" @click="onDetail(item)">
                <div class="product_list ">
                  <div class="img">
                    <img class="img-fluid w-100" :src="item.imageUrl" alt="">
                  </div>
                  <div class="txt">
                    <span class="productName">{{item.productName}}</span>
                  </div>
                </div>
              
              </div>
            </div>
           
          
          </div> 
            
          <!-- </div> -->
           
          </div>
          <div class="empty"></div>
          <div class="page" v-if="total>0">
            <el-pagination  background layout="prev, pager, next" :total="total" :page-size="pageSize" @current-change="changeSize"></el-pagination>
          </div>
         </div>
        </div>

        <!-- Team End -->
      </div>
  </div>
</template>

<script>
import productTypeLeft from "@/components/productTypeLeft.vue"
import {productList,productType,sceneList,projectList} from '@/api/modules/product'
export default {
  name: "Navimg",
  components:{
    productTypeLeft
  },
  data() {
    return {
      active:'',
      total:0,
      pageNum:1,
      pageSize:8,
      productType:'',
      sceneId:'',
      projectId:'',
      list:[],
    };
  },

  mounted(){
    this.getList()
  },
  
  methods: {

    onDetail(item){
        this.$emit('hideProduct')
        this.$router.push({
            // path: '/products/detail',
            path:'/productsdetail',
            query: {
               data:encodeURIComponent(JSON.stringify(item))
            }
        })
      },
    handleClick(e){},

    handleMouseLeave(){
      this.$emit('handleMouseLeave')
    },

    selectType(e){
        console.log('238928========sdsdsdkk',e)
        this.active=e.id
        this.total=0
        this.pageNum=1
        if(e.tab=='0'){
          this.productType=Number(e.id)
          this.sceneId=''
          this.projectId=''
        }else if(e.tab=='1'){
         this.sceneId=Number(e.id)
         this.productType=''
         this.projectId=''
        }else{
         this.projectId=Number(e.id)
         this.productType=''
         this.sceneId=''
        }
        this.getList()
 
      },

      // 改变页数
      changeSize(e){
        this.pageNum=e
        // this.paginate()
        this.getList()
      },

      // 分页
    paginate() {
      let currentP = this.pageNum - 1;
      return this.oldList.slice(currentP * this.pageSize, (currentP + 1) * this.pageSize);
    },

    // 切换产品分来
    changeValue(){
      this.total=0
      this.list=[]
    },

    // 获取产品列表
    getList(){
        let data={
          pageNum:this.pageNum,
          pageSize:8,
          language:this.$store.getters.lang
        }
        if(this.productType){
          data['productType']=this.productType
        }
        if(this.sceneId){
          data['sceneId']=this.sceneId
        }
        if(this.projectId){
          data['projectId']=this.projectId
        }
        console.log('6273=========zsasas',data)
        productList(data).then(res=>{
          if(res.returnCode==200){
            this.total=res.pageInfo.totalCount
            // this.total=res.data.length
            this.list=res.data
          }
        })
      },
  },
};
</script>

<style scoped>

.P_left{
  background-color:#fff;
  width:100%;
  position:absolute;
  z-index:9999;
  min-height:875px;
  box-shadow: 0px 0px 4px 2px rgba(30, 90, 235, 0.1);
}

.list_box{
  position:relative;
  min-height:875px;
}

.content_box{
    
    /* margin-top:10px; */
    min-height:875px;
    display:flex;
    /* align-items:center; */
    /* justify-content:center; */
    
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
  }



  .productName{
    display:inline-block;
    width:205px;
    white-space: nowrap;  
    overflow: hidden;    
    text-overflow: ellipsis;
  }

  .text-content {
    background-color: #fff;
    padding: 0 20px 50px;
    margin-top:10px;
  }

  .empty{
    height:80px;
    margin-top:15px;
  }

  .page{
    position:absolute;
    bottom:13px;
    height:80px;
    width: 100%;
    display:flex;
    justify-content:flex-end;
    align-items:center;
    padding-right:15px;
  }

  #left {
    margin: 20px 0;
  }

  #right {
    padding: 20px 0;
  }

  .img_box{
    padding:15px;
    border:1px solid #dedede;
  }

  #swiper .banner-swiper {
  width: 100%;
  height: 100%;
 }

 #swiper1 {
  background-color:#fff;
 }

#swiper1 .banner-swiper1 .swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
#swiper1 .banner-swiper1 .swiper-slide {
  position: relative;
  width:25%;
}

#swiper .banner-swiper .swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

#swiper .banner-swiper .swiper-slide {
  position: relative;
}

#swiper .banner-swiper .swiper-slide-title {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999999;
  width: 100%;
  height: 100%;
  color: #fff;
  background: rgba(51, 51, 51, 0.534);
  text-align: center;
  line-height: 80px;
}

#swiper .banner-swiper .swiper-slide-title > h1 {
  font-size: 50px;
  margin-top: 12%;
}

#swiper .banner-swiper .swiper-slide-title > p {
  font-size: 20px;
  margin-top: 1%;
  font-weight: 700;
}

/* 媒体查询（手机） */
  @media screen and (max-width: 768px) {
    #right {
      padding: 15px;
    }
    #swiper {
    height: 200px;
  }
  }

  .product_list .txt {
    text-align: center;
    display: block;
    line-height: 36px;
    background: #eee;
    font-size: 16px;
    padding: 0 10px;
    transition: all .3s;
  }

  .product_list .img {
    margin: 0;
    position: relative;
  }

  .product_list .img::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0);
    top: 0;
    left: 0;
    transition: all .3s;
  }

  .product_list:hover .txt {
    background: #036eb8;
    color: #fff;
  }

  .product_list:hover .img::before {
    background: rgba(0, 0, 0, .5);
  }

  .product_list .img::after {
    content: "";
    display: block;
    width: 50px;
    height: 50px;
    position: absolute;
    left: calc(50% - 25px);
    top: calc(50% - 25px);
    background: #fff url('../assets/hhdimg/pdsbg.png') no-repeat center;
    border-radius: 100px;
    transform: scale(0);
    transition: all .3s;
  }

  .product_list:hover .img::after {
    transform: scale(1);
  }

  /deep/ .el-pagination{
    display: flex;
    
  }

  /deep/ .el-pager{
    display:flex
  }

  /deep/ .el-pagination.is-background .el-pager li{
    width: 40px;
    height: 40px;
    border-radius: 50% !important;
    display: flex;
    justify-content: center;
    align-items: center;
    /* margin:0 !important; */
    font-size:18px;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
  }

  /deep/ .el-pagination .btn-prev{
    width: 40px;
    height: 40px;
    border-radius: 50% !important;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
  }

  /deep/ .el-pagination .btn-next{
    width: 40px;
    height: 40px;
    border-radius: 50% !important;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
  }

  /deep/ .el-pagination .btn-next .el-icon{
    font-size:18px !important;
  }

  /deep/  .el-pagination .btn-prev .el-icon{
    font-size:18px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/productList.vue